import { z } from 'zod';

import { PlaceIdParamsSchema } from '../customer/place-customer.schemas.js';

export const ListFiscalMovementsQuerySchema = z.looseObject({
  competenceFrom: z.iso.date().optional(),
  competenceTo: z.iso.date().optional(),
  cursor: z.string().optional(),
  limit: z.coerce.number().int().min(1).max(100).optional(),
});

export const ListFiscalMovementsParamsSchema = PlaceIdParamsSchema;

export const FiscalMovementListItemSchema = z.looseObject({
  id: z.uuid(),
  fiscalDocumentId: z.uuid().nullable(),
  fiscalDocumentItemId: z.uuid().nullable(),
  competenceDate: z.iso.date(),
  direction: z.string(),
  operationKind: z.string(),
  documentKind: z.string().nullable(),
  netTotalCents: z.string(),
  currency: z.string(),
  createdAt: z.iso.datetime(),
});

export const ListFiscalMovementsResponseSchema = z.looseObject({
  items: z.array(FiscalMovementListItemSchema),
  pagination: z.looseObject({
    cursor: z.string().nullable(),
    hasMore: z.boolean(),
    limit: z.number().int().positive(),
  }),
});

export const FiscalDocumentEventItemSchema = z.looseObject({
  id: z.uuid(),
  eventType: z.string(),
  eventSequence: z.number().int(),
  occurredAt: z.iso.datetime(),
  protocolNumber: z.string().nullable(),
  correlationId: z.string().nullable(),
  responsePayload: z.record(z.string(), z.unknown()).nullable(),
  createdAt: z.iso.datetime(),
});

export const ListFiscalDocumentEventsResponseSchema = z.looseObject({
  items: z.array(FiscalDocumentEventItemSchema),
});

export type ListFiscalMovementsQuery = z.infer<typeof ListFiscalMovementsQuerySchema>;
